import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { MdClose } from "react-icons/md";
import { Table as MaterialTable } from "@material-ui/core";
import utilityFunctions from "../../../store/utilityFunctions";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import LoadingPage from "../../../components/Loading/Loading";
import SetWarrantyDetails from "../../CustomerDetail/Devices/SetWarrantyDetails/SetWarrantyDetails";

class RaiseNewTicket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      fromDate: null,
      toDate: null,
      showFilterModal: true,
      customers: null,
      errorTxt: "",
      searchFilter: "",
    };
    const userInfo = utilityFunctions.getCookie("userInfo");
    this.userRole = JSON.parse(userInfo).user.role;
    this.user = JSON.parse(userInfo).user;
  }

  retrieveCustomerDevices = (id) => {
    this.setState({
      loading: true,
    });

    this.props
      .protectedFetch(
        config.backendServer + `customers/${id}/devices/`,
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const ticketTemp = res?.map((x) => x.tickets).flat();
        const ticketActivitiesTemp = ticketTemp
          .map((ticket) =>
            ticket.ticket_activities.map((item) => {
              return {
                activity: item,
                ticketNumber: ticket.ticket_number,
                ticketId: ticket.id,
              };
            })
          )
          .flat();

        this.setState({
          loading: false,
          customerDevices: res,
          tickets: ticketTemp,
          ticketActivities: ticketActivitiesTemp,
        });
        // this.retrieveCustomer(id);
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
        this.setState({
          loading: false,
          errorTxtDevice: "problem retrieving customer devices",
        });
      });
  };

  isValidEmail = (email) => {
    if (typeof email !== "string") return false;

    const value = email.trim().toLowerCase();
    const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    return re.test(value);
  };

  handleSearchCustomers = () => {
    this.setState({ loading: true });

    const url = `${config.backendServer}find/customers/`;

    this.props
      .protectedFetch(
        url,
        "GET",
        { query_email: this.state.searchFilter },
        errorFunctions.checkResponseThenJson
      )
      .then(async (res) => {
        if (res && res.results && res.results.length > 0) {
          this.setState({
            loading: false,
            customers: res.results[0] || null,
            errorTxt: "",
          });

          this.retrieveCustomerDevices(res.results[0].id);
        } else {
          this.setState({
            loading: false,
            errorTxt:
              "Customer not found. You will need to register a device first.",
            customers: null,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: false,
          errorTxt:
            "Customer not found. You will need to register a device first.",
          customers: null,
        });
      });
  };

  filterChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleKeyPressSearch = (e) => {
    if (e.key === "Enter") {
      this.handleValidationEmail();
    }
  };

  handleValidationEmail = () => {
    if (this.isValidEmail(this.state.searchFilter)) {
      this.handleSearchCustomers();
    } else {
      this.setState({
        errorTxt: "Please enter a valid email address",
      });
    }
  };

  handleChangeTicketLocation = (ticketId) => {
    this.setState({ loading: true });

    let payload = {
      store_location: this.props.userInfo.user.store_location_id,
    };

    this.props
      .protectedFetch(
        config.backendServer + `ticket/${ticketId}/change-location/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        alert("Change location success");
        this.props.retrieveWarranty?.(); //mini reload retrieveWarranty
        this.props.handleCloseModal();
        this.setState({ loading: false });
      })
      .catch((err) => {
        alert("Change location failed, please try again");
        console.log("fail", err);
        this.setState({ loading: false });
      });
  };

  render() {
    const closedStatus = [
      "Did Not Proceed",
      "Not Approved",
      "Service Completed",
      "Completed",
      "Refund Processed",
      "Replacement Sent",
      "Repair complete, goods sent out",
      "Spare Parts Dispatched, Issue Resolved",
      "Credit Claim Resolved / Completed",
    ];

    return (
      <>
        <div className="card">
          <button
            onClick={() => this.props.handleCloseModal()}
            className={"confirm-modal-close"}
          >
            <MdClose />
          </button>
          <div className="card-header">
            <h6>Raise New Ticket</h6>
          </div>
          <div className={"card-body"}>
            <div className="input-group  mb-3 ">
              <input
                type="email"
                placeholder="Search customers by email"
                id={"searchFilter"}
                required
                className={"form-control col-8"}
                onChange={this.filterChange}
                onKeyDown={this.handleKeyPressSearch}
                // onInput={()=> alert("submit")}
                value={this.state.searchFilter}
                // width={"50px"}
              />
              <div className="input-group-prepend">
                <span
                  className="form-control "
                  onClick={this.handleValidationEmail}
                >
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
            <div>
              <TableContainer className="border">
                <MaterialTable
                  aria-labelledby="tableTitle"
                  size={"large"}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Contact Number</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.customers ? (
                      <Fragment>
                        <TableRow>
                          <TableCell>{this.state.customers.name}</TableCell>
                          <TableCell>{this.state.customers.email}</TableCell>
                          <TableCell>{this.state.customers.mobile}</TableCell>
                        </TableRow>
                      </Fragment>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4}>{this.state.errorTxt}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </MaterialTable>
              </TableContainer>
            </div>
          </div>

          {this.state.loading ? (
            <LoadingPage small />
          ) : (
            <>
              {this.state.customers ? (
                <div className={"card-body h-200"}>
                  <TableContainer
                    className="border"
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    <MaterialTable
                      aria-labelledby="tableTitle"
                      size={"large"}
                      aria-label="enhanced table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Serial Number</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.customerDevices
                          ?.sort((a, b) =>
                            a.device.name.localeCompare(b.device.name)
                          )
                          .map((item, i) => {
                            const lastTicket =
                              item?.tickets[item.tickets.length - 1];
                            const lastTicketStatus = lastTicket?.status;

                            const canLogFault =
                              !lastTicketStatus ||
                              closedStatus.includes(lastTicketStatus);
                            const sameStore =
                              item?.customer_store_locations[0]?.id ===
                              this.props.userInfo.user.store_location_id;

                            return (
                              <TableRow key={i}>
                                <TableCell>{item.device.name}</TableCell>
                                <TableCell>{item.serial_number}</TableCell>

                                {canLogFault ? (
                                  <TableCell>
                                    <button
                                      className="k-btn k-btn-primary k-btn-sm"
                                      onClick={() =>
                                        this.setState({
                                          showApproveModal: true,
                                          userDevice: item?.id,
                                        })
                                      }
                                    >
                                      Log Fault
                                    </button>
                                  </TableCell>
                                ) : sameStore ? (
                                  <TableCell>
                                    Exist: ({lastTicket?.ticket_number})
                                  </TableCell>
                                ) : (
                                  <TableCell>
                                    Ticket: ({lastTicket?.ticket_number})
                                    <button
                                      className="k-btn k-btn-primary k-btn-sm"
                                      onClick={() =>
                                        this.handleChangeTicketLocation(
                                          lastTicket?.id
                                        )
                                      }
                                    >
                                      Assign Existing Device
                                    </button>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </MaterialTable>
                  </TableContainer>
                </div>
              ) : null}
            </>
          )}

          <div className={"card-footer"}>
            <button
              type="button"
              className={"btn btn-secondary"}
              onClick={() => this.props.handleCloseModal()}
            >
              Cancel
            </button>
          </div>
        </div>

        {/* Modal form for approving warranty form */}
        <SetWarrantyDetails
          userDevice={this.state.userDevice}
          customerId={this.state.customers?.id}
          protectedFetch={this.props.protectedFetch}
          showModal={this.state.showApproveModal}
          hideModal={() => {
            this.setState({ showApproveModal: false });
            this.props.handleCloseModal();
          }}
          retrieveDevicesNew={this.props.handleRefresh}
          handleRefresh={() => {
            this.props.handleRefresh();
          }}
          retrieveCustomerDevices={() => {}}
          isRegisterDevice={true}
          selectedbrandID={this.props.selectedbrandID}
        />
      </>
    );
  }
}

export default RaiseNewTicket;
